import { render, staticRenderFns } from "./AddOrderFOBDialog.vue?vue&type=template&id=5c648232&"
import script from "./AddOrderFOBDialog.vue?vue&type=script&lang=js&"
export * from "./AddOrderFOBDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports